import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
declare const require: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  passengers: {};

  constructor() {
    this.passengers = [
      {
        id: 1,
        name: 'passenger 1',
        client: 'Client 1',
        school: 'Ecole 1',
        bus: 'Bus 1',
        isPositionValide: 'Oui',
        activationKey: 'Oui'
      },
      {
        id: 2,
        name: 'passenger 2',
        client: 'Client 2',
        school: 'Ecole 2',
        bus: 'Bus 2',
        isPositionValide: 'Oui',
        activationKey: 'Oui'
      },
      {
        id: 3,
        name: 'passenger 3',
        client: 'Client 3',
        school: 'Ecole 3',
        bus: 'Bus 3',
        isPositionValide: 'Oui',
        activationKey: 'Oui'
      }
    ];

  }

  ngOnInit() {
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[0, 'asc']],
      ordering: false,
      columnDefs: [
        { orderable: false, targets: 0 }
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        processing: 'Traitement en cours...',
        search: 'Rechercher&nbsp;:',
        lengthMenu: 'Afficher _MENU_ &eacute;l&eacute;ments',
        info: 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        infoEmpty: 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        infoFiltered: '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        infoPostFix: '',
        loadingRecords: 'Chargement en cours...',
        zeroRecords: 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        emptyTable: 'Aucune donn&eacute;e disponible dans le tableau',
        paginate: {
          first: 'Premier',
          previous: 'Pr&eacute;c&eacute;dent',
          next: 'Suivant',
          last: 'Dernier'
        },
        aria: {
          sortAscending: ': activer pour trier la colonne par ordre croissant',
          sortDescending: ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
    };
  }


  downloadJourneyPDF() {
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.setFont('', 'bold');
    doc.text(15, 20, 'Nom Ecole: Noms bus - trajet');

    doc.setFontSize(14);
    doc.setFont('', 'bold');
    doc.text(15, 30, 'Horaire trajet:');
    doc.text(15, 40, 'Distance du trajet: ');
    doc.text(15, 50, 'Nom chauffeur: ');
    doc.text(15, 60, 'Tél chauffeur: ');
    doc.text(15, 70, 'Nom assistante: ');
    doc.text(15, 80, 'Tél assistante:');
    doc.setFont('', 'normal');
    doc.text(50, 30, '08:30 - 10:25');
    doc.text(57, 40, '120KM');
    doc.text(52, 50, 'Chauffeur 1');
    doc.text(50, 60, '03 62 55 82 23');
    doc.text(52, 70, 'assistante 1');
    doc.text(50, 80, '03 62 55 82 23');

    doc.autoTable({
      startY: 90,
      theme: 'striped',
      headStyles: {
        fillColor: '#000',
        textColor: '#fff'
      },
      head: [['order ', 'Nom', 'Prénom', 'Tél']],
      body: [
        ['1', 'Castille', 'David', '06 25 25 85 58'],
        ['2', 'Castille', 'David', '06 25 25 85 58'],
        ['3', 'Castille', 'David', '06 25 25 85 58'],
        ['4', 'Castille', 'David', '06 25 25 85 58'],
        ['5', 'Castille', 'David', '06 25 25 85 58'],
        ['6', 'Castille', 'David', '06 25 25 85 58'],
        ['7', 'Castille', 'David', '06 25 25 85 58'],
        ['8', 'Castille', 'David', '06 25 25 85 58'],
        ['9', 'Castille', 'David', '06 25 25 85 58'],
        ['10', 'Castille', 'David', '06 25 25 85 58'],
        ['11', 'Castille', 'David', '06 25 25 85 58'],
        ['12', 'Castille', 'David', '06 25 25 85 58'],
        ['13', 'Castille', 'David', '06 25 25 85 58'],
        ['14', 'Castille', 'David', '06 25 25 85 58'],
        ['15', 'Castille', 'David', '06 25 25 85 58']
      ]
    });
    // doc.addPage();

    doc.save('trajets.pdf');
  }

  downloadPassagerPDF() {
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.setFont('', 'bold');
    doc.text(15, 20, 'Nom Ecole: Noms bus - trajet');
    doc.autoTable({
      startY: 30,
      theme: 'striped',
      headStyles: {
        fillColor: '#000',
        textColor: '#fff'
      },
      head: [['nom', 'prénom', 'code']],
      body: [
        ['David', 'Castille', '45SDFD'],
        ['David', 'Castille', 'BVFDST'],
        ['David', 'Castille', 'ERTVDF'],
        ['David', 'Castille', 'STHTRE'],
        ['David', 'Castille', 'SDRVFD'],
        ['David', 'Castille', 'HBFRTY'],
        ['David', 'Castille', 'HTRYRTETTB'],
        ['David', 'Castille', 'BRUTR6'],
        ['David', 'Castille', 'BYRUBT'],
        ['David', 'Castille', 'RET58R'],
        ['David', 'Castille', 'RTREHG'],
        ['David', 'Castille', 'SJ6UR'],
        ['David', 'Castille', 'KTURT7YH'],
        ['David', 'Castille', 'SRY6UTHJS'],
        ['David', 'Castille', 'ETBTYUTRU'],
        ['David', 'Castille', 'REYEYJI'],
        ['David', 'Castille', 'BEUTR7U'],
        ['David', 'Castille', 'RUYTRTYR'],
        ['David', 'Castille', 'HTSTYHTU'],
        ['David', 'Castille', 'TYUUTR'],
      ]
    });
    // doc.addPage();

    doc.save('passager.pdf');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/planning-and-optimization/report/report.component.ts